<template>
  <div class="player-body" :class="{ visible: bodyVisible }" >
    <div class="control-body">
      <div class="play-btn" :class="{ playing: isPlaying }" @click="onPlayBtnClick">
        <span class="play"><img src="/static/img/yearluck/y2020/player/play.svg" /></span>
        <span class="pause"><img src="/static/img/yearluck/y2020/player/pause.svg" /></span>
      </div>
      <div class="playtime-indicator" @mousedown="onIndicatorClick">
        <span class="playpoint" ref="pp"></span>
        <div class="frame"><span class="fill" ref="fill"></span></div>
      </div>
      <div class="time">{{ timeformat(playTime) }}</div>
    </div>

    <audio
      id="yearluckVoicePlayer"
      :src="voicefile"
      preload="auto"
      @ended="onPlayFinish"
      @timeupdate="timeUpdate"
      @durationchange="durationChange"
    ></audio>
  </div>
</template>

<script>
export default {
  name: "voicePlayer",
  data() {
    return {
      audioBody: null,
      bodyVisible: false,
      isPlaying: false,
      playTime: 0,
      totalTime: 0,
      indSize: 0,
      closeIntervalTime: 7000,
      tmid: ''
    }
  },
  props: {
    voicefileReceive: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    voicefile() {
      return this.voicefileReceive
    }
  },
  mounted() {
    this.audioBody = document.getElementById('yearluckVoicePlayer')
  },
  methods: {
    onPlayFinish() {
      this.isPlaying = false
      this.tmid = setTimeout(()=>{this.bodyVisible = false}, this.closeIntervalTime)
    },
    onIndicatorClick(e) {
      clearTimeout(this.tmid)
      const ratio = e.offsetX / this.indSize
      const targetTime = this.totalTime * ratio

      const tmpFill = this.$refs.fill.style.transition
      const tmpPp = this.$refs.pp.style.transition

      this.$refs.fill.style.transition = 'none'
      this.$refs.pp.style.transition = 'none'

      this.audioBody.currentTime = targetTime
      this.timeUpdate()
      this.$nextTick(()=>{
        this.$refs.fill.style.transition = tmpFill
        this.$refs.pp.style.transition = tmpPp
      })
    },
    onPlayBtnClick() {
      clearTimeout(this.tmid)
      this.indSize = this.$refs.pp.parentNode.clientWidth
      if(this.isPlaying) {
        this.isPlaying = false
        this.audioBody.pause()
      }else {
        this.isPlaying = true
        this.audioBody.play()
      }
    },
    timeUpdate(e){
      this.playTime = this.audioBody.currentTime
      const ratio = Math.ceil( this.playTime / this.totalTime * 1000) / 1000
      this.$refs.fill.style.transform = `scale(${ratio}, 1)`
      this.$refs.pp.style.transform = `translate(${ this.indSize * ratio }px, 0)`
    },
    durationChange() {
      this.totalTime = this.audioBody.duration
    },
    playVoice(){
      this.bodyVisible = true
      this.onPlayBtnClick()
    },
    timeformat(val){
      let remain = this.totalTime != null ? this.totalTime - val : 0
      let sec = parseInt(remain % 60)
      let min = Math.floor(remain / 60)
      return `${min}:${String('0' + sec).slice(-2)}`
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../../../sass/variables//index';
.player-body {
  $playerH: 60px;
  width: 100%;
  height: $playerH;
  position: fixed;
  background: $brown-10;
  color: white;
  bottom: -$playerH;
  left: 0;
  transition: all 300ms ease-out 0s;
  opacity: 0;
  padding-left: 15px;
  padding-right: 20px;
  z-index: 1000;
  &.visible {
    transform: translate(0, -$playerH);
    opacity: 1;
  }
  .control-body {
    width: 100%;
    height: 100%;
    max-width: 420px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .play-btn {
      width: 30px;
      height: 30px;
      flex-basis: 30px;
      position: relative;
      cursor: pointer;
      outline: none;
      user-select: none;
      .play,
      .pause {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        opacity: 0;
        transform: scale(0.5);
        transition: all 200ms ease-out 0s;
      }
      .play {
        opacity: 1;
        transform: scale(1);
      }
      .pause {
        opacity: 0;
        transform: scale(0.5);
      }
      &.playing {
        .play {
          opacity: 0;
          transform: scale(0.5);
        }
        .pause {
          opacity: 1;
          transform: scale(1);
        }
      }
    }
    .playtime-indicator {
      padding: 12px 0;
      position: relative;
      width: 200px;
      cursor: pointer;
      @include mq() {
        width: 300px;
      }
      .frame {
        width: 100%;
        height: 2px;
        background: #b09070;
        border-radius: 2px;
        pointer-events: none;
        .fill {
          pointer-events: none;
          transition: transform 200ms linear 0s;
          display: block;
          width: 100%;
          height: 100%;
          transform-origin: left center;
          transform: scale(0, 1);
          background: white;
        }
      }
      .playpoint {
        display: block;
        width: 8px;
        height: 8px;
        position: absolute;
        border-radius: 4px;
        left: -4px;
        top: 0;
        bottom: 0;
        margin: auto;
        background: white;
        transition: transform 200ms linear 0s;
      }
    }
    .time {
      font-size: 13px;
    }
  }
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/voicePlayer.vue